export enum TiktokDevice {
  Android = "ANDROID",
  IOS = "IOS",
}
